/**
 * `location` for `EventLocationProvider` around shop header chrome.
 */
export const HEADER_EVENT_LOCATION = "header";

/**
 * `target` segment for `getEventName` when wrapped with `HEADER_EVENT_LOCATION`.
 */
export const HEADER_ANALYTICS_TARGET = {
  SELF: "self",
  OTHER: "other",
  SEND_CTA: "send_cta",
  REDEEM: "redeem",
  WALLET: "wallet",
  SEND_POINTS_LINK: "send_points_link",
  PROFILE_MENU: "profile_menu",
  MY_SHOPS: "my_shops",
  ACCOUNT_SETTINGS: "account_settings",
  WORKSPACE: "workspace",
  SEARCH: "search",
  LANGUAGE: "language",
  COUNTRY: "country",
  HELP_CENTER: "help_center",
  LOGOUT: "logout",
};
